import { Box, Typography } from "@material-ui/core";
import React, { useMemo } from "react";
import { RouteComponentProps } from "react-router-dom";
import { isEqual } from "lodash-es";
import clsx from "clsx";

import { ActionLink } from "halifax";
import { TripadvisorRatingRefinement } from "redmond";

import "./styles.scss";
import { type AvailabilityFilterProps } from "./container";
import {
  DurationFilter,
  PopularFeaturesFilter,
  PriceFilter,
  StartTimeFilter,
  TripadvisorRatingFilter,
} from "../AvailabilityFilters";
import { CLEAR_ALL_FILTERS } from "../../textConstants";
import {
  AVAILABLE,
  getExperimentVariant,
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../../context/experiments";

export interface IAvailabilityFilterProps
  extends RouteComponentProps,
    AvailabilityFilterProps {}

export const AvailabilityFilter = (props: IAvailabilityFilterProps) => {
  const {
    filteredTripAdvisorRating,
    setFilterTripadvisorRating,
    filteredStartTimes,
    setFilterStartTimes,
    filteredDurationTimes,
    setFilterDurationTimes,
    maxExperiencesPrice,
    filteredPrice,
    setFilterPrice,
    experiencesPopularTagsList,
    popularFeatures,
    setFilterPopularFeatures,
    minExperiencePrice,
    resetFilterAndSort,
    activitiesAvailabilityProperties,
  } = props;

  const expState = useExperiments();
  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  const canReset = useMemo(
    () =>
      filteredTripAdvisorRating !== TripadvisorRatingRefinement.Any ||
      !isEqual(filteredStartTimes, []) ||
      !isEqual(filteredDurationTimes, []) ||
      filteredPrice.maxPriceUSD !== maxExperiencesPrice?.fiat.value ||
      !isEqual(popularFeatures, []),
    [
      filteredTripAdvisorRating,
      filteredStartTimes,
      filteredDurationTimes,
      popularFeatures,
      filteredPrice,
      maxExperiencesPrice,
    ]
  );

  return (
    <Box
      className={clsx("experiences-availability-all-filter-container", {
        xmod: isXmodRedesign,
      })}
    >
      <Box className="experiences-availability-header">
        <Typography className="title" variant="h6">
          All filters
        </Typography>
        {canReset && (
          <ActionLink
            className="filters-reset-button"
            content={CLEAR_ALL_FILTERS}
            onClick={resetFilterAndSort}
          />
        )}
      </Box>
      <Box>
        <TripadvisorRatingFilter
          filteredTripAdvisorRating={filteredTripAdvisorRating}
          setFilterTripadvisorRating={setFilterTripadvisorRating}
          activitiesAvailabilityProperties={activitiesAvailabilityProperties}
        />
        <StartTimeFilter
          filteredStartTimes={filteredStartTimes}
          setFilterStartTimes={setFilterStartTimes}
          activitiesAvailabilityProperties={activitiesAvailabilityProperties}
        />
        <DurationFilter
          filteredDurationTimes={filteredDurationTimes}
          setFilterDurationTimes={setFilterDurationTimes}
          activitiesAvailabilityProperties={activitiesAvailabilityProperties}
        />
        {maxExperiencesPrice && minExperiencePrice && (
          <PriceFilter
            maxPrice={maxExperiencesPrice}
            filterPrice={filteredPrice}
            setFilterPrice={setFilterPrice}
            minPrice={minExperiencePrice}
            activitiesAvailabilityProperties={activitiesAvailabilityProperties}
          />
        )}
        <PopularFeaturesFilter
          popularFeaturesList={experiencesPopularTagsList}
          filteredPopularFeatures={popularFeatures}
          setFilteredPopularFeatures={setFilterPopularFeatures}
          activitiesAvailabilityProperties={activitiesAvailabilityProperties}
        />
      </Box>
    </Box>
  );
};
